export enum PaymentMethod {
  NEW_CREDIT_CARD = 0,
  EXISTING_CREDIT_CARD = 1,
  TELCELL = 2,
  IDRAM = 3,
  EASY_WALLET = 4 ,
  MY_PAY = 5,
  FASTSHIFT = 6,
  APPLE_PAY = 7
}
